export const translations = {
    'step_1': {
        'en': 'Information',
        'fr': 'Coordonnées'
    },
    'step_2': {
        'en': 'Select',
        'fr': 'Sélection'
    },
    'step_3': {
        'en': 'Schedule',
        'fr': 'Réservation'
    },
    'tell_us_heading': {
        'en': 'Tell us about yourself.',
        'fr': 'Parlez-nous un peu de vous.'
    },
    'tell_us_heading_rep': {
        'en': 'Dealer Information',
        'fr': 'Dealer Information'
    },
    'reserve_your_spot': {
        'en': 'Reserve Your Spot Today!',
        'fr': ''
    },
    'first_name' : {
        'en': 'First Name',
        'fr': 'Prénom'
    },
    'last_name' : {
        'en': 'Last Name',
        'fr': 'Nom'
    },
    'email' : {
        'en': 'Email Address',
        'fr': 'Courriel'
    },
    'phone' : {
        'en': 'Mobile Phone Number',
        'fr': 'Téléphone'
    },
    'country' : {
        'en': 'Country',
        'fr': 'Pays'
    },
    'united_states' : {
        'en': 'United States',
        'fr': 'États-Unis'
    },

    'postal_code': {
        'en': 'Postal Code',
        'fr': 'Code postal'
    },
    'dealership_name': {
        'en': 'Dealership Name',
        'fr': 'Nom du commerce'
    },
    'title': {
        'en': 'Title',
        'fr': 'Titre du poste'
    },
    'sms_heading': {
        'en': 'Opt in for text message appointment reminders',
        'fr': 'Abonnez-vous aux rappels de rendez-vous par texto†'
    },
    'sms_label': {
        'en': 'Yes! Send me text message reminders',
        'fr': 'Oui! Envoyez-moi des rappels par texto'
    },
    'sms_disclaimer': {
        'en': 'By submitting my information, I agree to the <a href="https://www.coxautoinc.com/privacy-statement/" target="_blank" rel="noopener noreferrer">PRIVACY POLICY</a> and the <a href="https://www.coxautoinc.com/terms/sms/" target="_blank" rel="noopener noreferrer">TERMS & CONDITIONS</a>. I also provide my consent for Cox Automotive, its affiliates, and associated brands to send me timely offers and useful information via emails, phone calls, and SMS messages at the number and email addresses provided in this form about the NADA Expo and the products and services offered during it. I understand that my consent is not required as a condition of purchase and that message and data rates may apply.',
        'fr': ''
    },
    'required_fields': {
        'en': 'Required fields',
        'fr': 'Champs requis'
    },
    'next': {
        'en': 'Next',
        'fr': 'SUIVANT'
    },
    'demos_heading': {
        'en': 'What demos would you like to schedule',
        'fr': 'Quelle démo aimeriez-vous recevoir?'
    },
    'check_all': {
        'en': 'Check all that apply',
        'fr': 'cochez toutes celles qui vous intéressent!'
    },
    'back': {
        'en': 'Back',
        'fr': 'RETOUR'
    },
    'schedule_demos': {
        'en': 'Schedule My Demos',
        'fr': 'RÉSERVER MA DÉMO'
    },
    'missing_field': {
        'en': 'Missing required field',
        'fr': 'Champ obligatoire manquant'
    },
    'valid_email': {
        'en': 'Please enter a valid email address',
        'fr': 'Un courriel valide est requis'
    },
    'valid_phone': {
        'en': 'Please enter a valid phone number (No dashes or spaces)',
        'fr': 'Un numéro de téléphone valide est requis'
    },
    'valid_zip': {
        'en': 'Valid zip is required',
        'fr': 'Valid zip is required'
    },
    'validation_heading': {
        'en': 'Please complete the following required fields',
        'fr': 'Veuillez remplir les champs obligatoires suivants'
    },
    'select_one': {
        'en': 'Select at least one',
        'fr': 'Sélectionnez-en au moins un'
    },
    'is_not valid': {
        'en': 'is not valid',
        'fr': "n'est pas valide"
    },
    'too_short': {
        'en': 'Too short',
        'fr': 'Trop court'
    },
    'too_long': {
        'en': 'Too long. Max. chars',
        'fr': 'Trop long. Max. chars'
    },
    'sms_optin': {
        'en': 'Opt in for text message appointment reminders',
        'fr': 'Abonnez-vous aux rappels de rendez-vous par texto†'
    },
    'mobile': {
        'en': 'Mobile',
        'fr': 'Mobile'
    },
    'sign_up_for_sms': {
        'en': 'Sign Up for SMS',
        'fr': 'Sign Up for SMS'
    },
    'heres_your_schedule': {
        'en': 'Here’s What You’ve Signed Up For',
        'fr': ''
    },
    'heres_your_schedule_will_not_attend': {
        'en': 'Here are the Demos You’ve Requested Information About',
        'fr': ''
    },
    'representative_will_contact': {
        'en': 'A Representative will be reaching out to you soon to follow up and schedule your personal demo.',
        'fr': ''
    },
    'schedule_email': {
        'en': 'An email with your schedule will be sent to',
        'fr': 'Votre réservation vous sera envoyée à cette adresse:'
    },
    'thank_you_for_registering': {
        'en': 'Thank You for Registering',
        'fr': 'VOTRE RÉSERVATION EST CONFIRMÉE! MERCI!'
    },
    'add_to_calendar': {
        'en': 'Add to Calendar',
        'fr': 'Ajouter au calendrier'
    },
    'other': {
        'en': 'Other',
        'fr': 'Autre'
    },
    'willAttend': {
        'en': 'Are you planning on attending NADA 2025?',
        'fr': 'Are you planning on attending NADA 2025?'
    },
    'willAttendRep': {
        'en': 'Are you planning on attending NADA 2025?',
        'fr': 'Are you planning on attending NADA 2025?'
    },
    'demoLocation': {
        'en': 'Where should this demo take place?',
        'fr': 'Where should this demo take place?'
    },
    'demoLocationRoom': {
        'en': 'In a meeting room',
        'fr': 'In a meeting room'
    },
    'demoLocationBooth': {
        'en': 'At a booth station',
        'fr': 'At a booth station'
    }
}

export const getTranslation = (key, lang = 'en') => {
    if(!translations[key] || !translations[key][lang]) {
        return '';
    }
    
    return translations[key][lang];}
